{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://modules/psu-award",
  "title": "PSU Award",
  "description": "PSU (Performance Stock Unit) award — create and edit unified form.",
  "type": "object",
  "properties": {
    "participantId": {
      "$ref": "module://participant#/$defs/participantId",
      "actionId": "FETCH_PSU_AWARD_PARTICIPANTS"
    },
    "id": {
      "type": "string",
      "title": "Award ID",
      "widget": "hidden"
    },
    "firstName": {
      "$ref": "module://participant#properties/firstName"
    },
    "middleName": {
      "$ref": "module://participant#properties/middleName"
    },
    "lastName": {
      "$ref": "module://participant#properties/lastName"
    },
    "awardNumber": {
      "type": "string",
      "title": "Award Number",
      "maxLength": 100,
      "noBlank": true
    },
    "grantId": {
      "type": "string",
      "title": "Grant Name",
      "format": "uuid",
      "widget": "select",
      "actionId": "FETCH_PSU_AWARD_GRANTS"
    },
    "performanceRuleName": {
      "type": "string",
      "title": "Performance Rule",
      "noBlank": true,
      "noDoubleSpace": true
    },
    "performanceRuleId": {
      "type": "string",
      "title": "Performance Rule ID",
      "widget": "hidden"
    },
    "planId": {
      "type": "string",
      "title": "Plan",
      "format": "uuid",
      "widget": "hidden"
    },
    "planName": {
      "type": "string",
      "title": "Plan Name",
      "noBlank": true,
      "noDoubleSpace": true
    },
    "planTypeId": {
      "type": "string",
      "title": "Plan Type ID",
      "widget": "hidden"
    },
    "planType": {
      "type": "string",
      "title": "Plan Type"
    },
    "grantName": {
      "type": "string",
      "title": "Grant Name",
      "widget": "hidden"
    },
    "isOffline": {
      "type": "boolean",
      "title": "Is Offline",
      "widget": "hidden"
    },
    "issuedUnits": {
      "type": "integer",
      "title": "Issued Units",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "fmvAtGrant": {
      "type": "number",
      "title": "FMV at Grant ($)",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4,
      "displayFormat": "currency"
    },
    "grantPrice": {
      "type": "number",
      "title": "Grant Value ($)",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4,
      "displayFormat": "currency"
    },
    "grantValue": {
      "type": "number",
      "title": "Intended Grant Value ($)",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4,
      "displayFormat": "currency"
    },
    "grantIssueDate": {
      "type": "string",
      "title": "Grant Date",
      "format": "date"
    },
    "vestingStartDate": {
      "type": "string",
      "title": "Vesting Start Date",
      "format": "date"
    },
    "vestingTemplateId": {
      "type": "string",
      "title": "Vesting Template Name",
      "format": "uuid",
      "widget": "select",
      "actionId": "FETCH_VESTING_TEMPLATES"
    },
    "vestingTemplateName": {
      "type": "string",
      "title": "Vesting Schedule",
      "widget": "hidden"
    },
    "vestingSchedule": {
      "type": "string",
      "title": "Vesting Template Name"
    },
    "poolId": {
      "type": "string",
      "title": "Share Pool",
      "format": "uuid",
      "widget": "select",
      "actionId": "FETCH_SHARE_POOLS"
    },
    "grantReason": {
      "type": "string",
      "title": "Grant Reason",
      "maxLength": 200,
      "noBlank": true,
      "noDoubleSpace": true
    },
    "notes": {
      "type": "string",
      "title": "Notes",
      "maxLength": 200,
      "noBlank": true,
      "noDoubleSpace": true
    },
    "settlementTypeId": {
      "$ref": "module://settlement#/$defs/settlementTypeId"
    },
    "isAccepted": {
      "type": "boolean",
      "title": "Is Accepted",
      "widget": "select",
      "options": [
        {
          "label": "Yes",
          "value": true
        },
        {
          "label": "No",
          "value": false
        }
      ]
    },
    "acceptanceDate": {
      "type": "string",
      "title": "Acceptance Date",
      "format": "date"
    },
    "awardAcceptanceDocumentInput": {
      "type": "file",
      "title": "Upload Acceptance Documents",
      "accept": ".pdf,.doc,.docx,.jpg,.jpeg,.png",
      "maxSize": 10485760,
      "fileUpload": {
        "multiple": false,
        "maxFiles": 1,
        "existingId": "#/properties/acceptanceDocumentId",
        "existingName": "#/properties/acceptanceDocumentName",
        "removedIds": "#/properties/acceptanceDocumentRemovedIds",
        "submit": {
          "selection": "all",
          "arrayKey": "acceptanceDocument",
          "deleteIdsKey": "documentIdsToDelete"
        }
      }
    },
    "acceptanceDocumentRemovedIds": {
      "type": "array",
      "items": { "type": "string" },
      "title": "Removed Acceptance Document IDs",
      "widget": "hidden",
      "default": []
    },
    "acceptanceDocumentId": {
      "type": "string",
      "title": "Acceptance Document ID",
      "format": "uuid",
      "widget": "hidden"
    },
    "acceptanceDocumentName": {
      "type": "string",
      "title": "Acceptance Document Name"
    },
    "acceptanceMethodId": {
      "type": "integer",
      "title": "Acceptance Method ID",
      "widget": "hidden"
    },
    "acceptanceMethodName": {
      "type": "string",
      "title": "Acceptance Method"
    },
    "methodType": {
      "type": "string",
      "title": "Acceleration Type",
      "widget": "select",
      "actionId": "FETCH_AWARD_METHOD_TYPES"
    },
    "methodTypeId": {
      "type": "integer",
      "title": "Method Type ID",
      "widget": "hidden"
    },
    "awardAdjustmentMethodId": {
      "type": "integer",
      "title": "Award Adjustment Method ID",
      "widget": "hidden"
    },
    "asOfDate": {
      "type": "string",
      "title": "As Of Date",
      "format": "date",
      "requiredWhen": {
        "field": "#/properties/methodType",
        "notEmpty": true
      }
    },
    "residualDate": {
      "type": "string",
      "title": "Residual Date",
      "format": "date"
    },
    "amortizationDate": {
      "type": "string",
      "title": "Amortization Date",
      "format": "date"
    },
    "cancelShareTypeId": {
      "type": "string",
      "title": "Cancel Share Type",
      "widget": "select",
      "actionId": "FETCH_CANCEL_SHARE_TYPES"
    },
    "targetCancelled": {
      "type": "integer",
      "title": "Target Cancelled",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number",
      "requiredWhen": {
        "allOf": [
          { "field": "#/properties/methodType", "notEmpty": true },
          { "field": "#/properties/cancelShareTypeId", "isEmpty": true }
        ]
      }
    },
    "targetOutStanding": {
      "type": "integer",
      "title": "Target Outstanding",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number",
      "widget": "hidden"
    },
    "adjustmentReason": {
      "type": "string",
      "title": "Adjustment Reason",
      "widget": "select",
      "options": [
        { "label": "Termination", "value": "Termination" },
        { "label": "Adjustment", "value": "Adjustment" }
      ]
    }
  }
}
